/**
 * 배포 사이트 상수 — 공유 URL·OG 이미지 절대경로를 한 곳에서 파생한다.
 * 언어별 정적 페이지(scripts/gen-i18n-pages.mjs)와 경로 규칙이 일치해야 한다.
 */
import { LOCALE } from '../i18n/i18n';
import type { Locale } from '../i18n/locales';

/** 배포 오리진(index.html의 og:url, scripts/locale-meta.mjs의 SITE와 동일). */
const ORIGIN = 'https://desk-smash.taehun.dev';

/** 로케일의 배포 경로. en은 루트('/'), 그 외는 '/<loc>/'. */
function localePath(locale: Locale = LOCALE): string {
  return locale === 'en' ? '/' : `/${locale}/`;
}

/** 접속 언어 페이지의 공유 URL(크롤러가 해당 언어 OG 카드를 받도록). */
export function shareUrl(locale: Locale = LOCALE): string {
  return `${ORIGIN}${localePath(locale)}`;
}

/** 접속 언어의 OG 공유 카드 절대 URL. en은 기본 og-image.png. */
export function ogImageUrl(locale: Locale = LOCALE): string {
  return `${ORIGIN}${locale === 'en' ? '/og-image.png' : `/og-image-${locale}.png`}`;
}
